import {handleActions} from 'redux-actions'
import {
    CANCEL_SESSION_TRANSFER,
    RECEIVE_SESSION_TRANSFER,
    RECEIVE_CANCEL_SESSION_TRANSFER,
    RECEIVE_SESSION_TRANSFER_RESPONSE
} from '../constants/ActionTypes'

const initialState = {
    status: 'idle',
    sender: '',
    option: '',
    serviceRequestId: '',
    comments: ''
}

const reducers = {}

reducers[RECEIVE_SESSION_TRANSFER] = {
    next(state, action) {
        return Object.assign({}, state, {
            status: 'receive',
            sender: action.payload.sender,
            option: action.payload.option,
            serviceRequestId: action.payload.serviceRequestId,
            comments: action.payload.comments,
            customerUserId: action.payload.customerUserId
        })
    }
}

reducers[RECEIVE_SESSION_TRANSFER_RESPONSE] = {
    next(state, action) {
        return Object.assign({}, state, initialState)
    }
}



reducers[CANCEL_SESSION_TRANSFER] = {
    next(state, action) {
        return Object.assign({}, state, initialState)
    }
}

reducers[RECEIVE_CANCEL_SESSION_TRANSFER] = {
    next(state, action) {
        if (state.serviceRequestId === action.payload.serviceRequestId) {
            return Object.assign({}, state, initialState)
        } else {
            return state
        }
    }
}


export default handleActions(reducers, initialState)
